import { TextField, Card, Grid, Button, Typography } from '@mui/material'
import { useHistory, Link as RouterLink } from 'react-router-dom'
import ROUTE from 'constant/route'

const PaddingY = { padding: '16px 0' }
function ForgetPasswordPage() {
    const history = useHistory()
    return (
        <div
            style={{
                display: 'flex',
                height: '100vh',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
            }}
        >
            <Card
                sx={{
                    width: '450px',
                    padding: '32px 24px',
                    textAlign: 'left',
                }}
            >
                <Typography sx={PaddingY} variant="h5" component="h5">
                    APP
                </Typography>
                <Grid sx={PaddingY}>
                    <Typography variant="h5" component="h5">
                        Forgot password?
                    </Typography>
                    <Typography variant="subtitle1">
                        Enter your email below to get reset password link.
                    </Typography>
                </Grid>

                <Grid container direction="column">
                    <TextField
                        sx={{ padding: '20px 0' }}
                        label="Email"
                        InputLabelProps={{ shrink: true }}
                    ></TextField>
                </Grid>
                <Grid
                    sx={PaddingY}
                    container
                    direction="row"
                    justifyContent="space-between"
                >
                    <RouterLink
                        style={{ textDecoration: 'none' }}
                        to={ROUTE.LOGIN}
                    >
                        Back to login
                    </RouterLink>
                    <Button
                        onClick={() => {
                            history.push('/')
                        }}
                        color="primary"
                    >
                        Reset Password
                    </Button>
                </Grid>
            </Card>
        </div>
    )
}

export default ForgetPasswordPage
